import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
	selector: 'app-date-months-val',
	templateUrl: './date-months-val.component.html',
	styleUrls: ['./date-months-val.component.scss']
})
export class DateMonthsValComponent implements OnInit {
	public months = [false, false, false, false, false, false, false, false, false, false, false, false];
	public default = [false, false, false, false, false, false, false, false, false, false, false, false];

	@Output() public valueChange: EventEmitter<string> = new EventEmitter<string>();

	@Input()
	public set value(val: string) {
		this.months = this.default.slice(0);
		const vals = val.split(',');
		for (const month of vals) {
			this.months[month] = true;
		}
	}
	public get value(): string {
		const values = [];
		const l = this.months.length;
		for (let i = 0; i < l; i++) {
			if (this.months[i] === true) {
				values.push(i);
			}
		}
		return values.join(',');
	}


	constructor() { }

	ngOnInit(): void {
	}
	HandleToggle( value, month) {
		this.months[month] = value;
		this.valueChange.emit(this.value);
	}

}
